import React, { useEffect, useRef } from 'react';
import { getIcon } from '../shared/FormatHelpers';

const EditFileMany = ({ value, setValue, isInvalid, addButtonText, removeButtonText }) => {

    console.log(addButtonText, removeButtonText);
    const inputRef = useRef();

    useEffect(() => {
        if (value === undefined || value === null) {
            setValue([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (e) => {
        if (!e.target.files.length) {
            return;
        }

        let v = value || [];
        setValue([...v, e.target.files[0]]);
    }

    const onAddButtonClick = () => inputRef.current?.click();

    const onClickRemoveFile = (e, index) => {
        e.preventDefault();

        setValue(value.filter((_, i) => i !== index));
    }

    return (
        <div className='crm-file-select-wrapper'>
            <input
                type="file"
                ref={inputRef}
                onChange={(e) => onChange(e)}
            />

            <div className={'space-y-2'}>
                {(value && value.length > 0) ?
                    <ul className={'m-0 p-2 space-y-2 border'}>
                        {value && value.map((file, index) => {
                            return (
                                <li className={'d-flex align-items-center m-0 p-0 space-x-1'} key={index}>
                                    {getIcon('file')}
                                    <span>{file.name}</span>
                                    <a href="#" className={'text-danger opacity-50 hover:opacity-100 pl-2'} onClick={(e) => onClickRemoveFile(e, index)}>
                                        {removeButtonText || 'Ta bort'}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                : null}

                <button type="button" className={'btn btn-outline-primary btn-sm mt-1'} onClick={onAddButtonClick}>{addButtonText || 'Bifoga fil'}</button>
            </div>
        </div>
    );
};

export default EditFileMany;
